import React, { useState } from 'react';
import KYPPreviewModal from './KYPPreviewModal';

const KYPPDFGenerator = ({ application, kypData, onClose }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  // Sample data for testing if no application data is provided
  const sampleApplication = {
    applicationId: 'APP123456',
    patient: {
      name: 'JOHN DOE',
      age: 45,
      gender: 'MALE',
      phone: '+91-9876543210',
      email: 'john.doe@example.com',
    },
    ...application
  };

  const sampleKypData = {
    applicationDetails: {
      applicationId: 'APP123456',
      hospitalName: 'SAMPLE MULTI-SPECIALITY HOSPITAL',
      diagnosis: 'Cardiac Surgery',
      treatmentType: 'SURGICAL',
      procedureName: 'Bypass Surgery',
      admissionDate: '15 January 2025',
      dischargeDate: 'TBD',
      roomEligibility: 'Single AC Room',
      insuranceCompany: 'National Insurance',
      policyNumber: 'POL123456789',
      tpaName: 'Medi Assist',
      primaryInsuredName: 'JOHN DOE',
      relationshipWithPrimary: 'Self',
      sumInsured: 500000,
      balanceSumInsured: 450000,
      roomAmountPerDay: 3000,
      icuAmountPerDay: 5000,
      policyPeriod: '1 April 2024 to 31 March 2025',
      intimationId: 'CIR/2025/123456',
    },
    // Policy Verification Data - Dynamic fields from Policy Writer
    policyVerification: {
      roomEligibility: {
        type: 'Single AC Room',
        dailyLimit: 3000,
        totalRoomLimit: 150000,
        calculationBasis: 'Daily room rent capping as per policy terms',
        currentUtilization: 15000,
        balanceAvailable: 135000
      },
      icuEligibility: {
        type: 'ICU/ICCU',
        dailyLimit: 5000,
        totalIcuLimit: 250000,
        calculationBasis: 'ICU charges capped at 2x room rent or actual whichever is lower',
        currentUtilization: 25000,
        balanceAvailable: 225000
      },
      coPayStructure: [
        {
          category: 'Room & Boarding',
          percentage: 10,
          applicableAmount: 50000,
          coPayAmount: 5000,
          description: '10% co-payment on room charges'
        },
        {
          category: 'Surgery & Medical Procedures',
          percentage: 15,
          applicableAmount: 200000,
          coPayAmount: 30000,
          description: '15% co-payment on surgical procedures'
        },
        {
          category: 'Diagnostics',
          percentage: 20,
          applicableAmount: 25000,
          coPayAmount: 5000,
          description: '20% co-payment on diagnostic tests'
        }
      ],
      deductiblesAndSublimits: [
        {
          type: 'Compulsory Deductible',
          amount: 25000,
          description: 'Mandatory deductible per policy year',
          utilized: 10000,
          balance: 15000,
          applicability: 'Per policy year'
        },
        {
          type: 'Procedure Sublimits - Cardiac Surgery',
          amount: 300000,
          description: 'Maximum limit for cardiac procedures',
          utilized: 75000,
          balance: 225000,
          applicability: 'Per procedure/Per policy year'
        },
        {
          type: 'Pre/Post Natal Limit',
          amount: 50000,
          description: 'Maternity coverage limit',
          utilized: 0,
          balance: 50000,
          applicability: 'Per pregnancy'
        },
        {
          type: 'Emergency Ambulance',
          amount: 2000,
          description: 'Per emergency transport',
          utilized: 1500,
          balance: 500,
          applicability: 'Per incident'
        }
      ]
    },
    medicalHistoryVerified: true,
    documentsAuthentic: true,
    treatmentAppropriate: true,
    doctorName: 'Medical Review Specialist',
    registrationNo: 'MED-001',
  validityPeriod: '15 days',
    coPay: '10%',
    preExistingConditions: 'None declared',
    clinicalNotes: 'Standard medical protocols followed. Treatment aligns with medical necessity. Policy verification completed with all dynamic calculations.',
    recommendation: 'Treatment is medically necessary and appropriate for the patient\'s condition. All policy limits and co-payment structures have been verified.',
    letterRemarks: 'Patient requires immediate attention for cardiac procedure. All pre-authorization requirements have been met and verified. Policy verification data synchronized from Policy Writer system.',
    leadGenerator: {
      companyName: 'SRI ABIRAKSHA',
      name: 'Sri Abiraksha Healthcare', 
      tagline: 'A Healthcare platform for All Healthcare requisite',
      city: 'Bangalore',
      description: 'Healthcare Insurance Processing & Medical Solutions',
    },
    ...kypData
  };

  const handlePreview = () => {
    setShowPreview(true);
  };

  const handleTest = () => {
    setShowPreview(true);
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif' 
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '15px',
        borderBottom: '2px solid #8B4513'
      }}>
        <h1 style={{ 
          color: '#8B4513', 
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          Comprehensive Professional KYP Letter Generator
        </h1>
        {onClose && (
          <button
            onClick={onClose}
            style={{
              background: '#dc3545',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Close
          </button>
        )}
      </div>

      {/* Control Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '15px', 
        marginBottom: '20px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={handleTest}
          style={{
            background: '#8B4513',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          🔍 Test KYP Preview Modal
        </button>

        <button
          onClick={handlePreview}
          style={{
            background: '#A0522D',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          👁️ Preview with Dynamic Policy Data
        </button>
      </div>

      {/* Features List */}
      <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px',
        border: '1px solid #e9ecef',
        marginBottom: '20px'
      }}>
        <h3 style={{ color: '#8B4513', marginTop: '0', marginBottom: '15px' }}>
          ✨ Enhanced Multi-Page Features with Dynamic Policy Data:
        </h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '10px'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Dynamic Policy Verification:</strong> Real-time room eligibility & ICU calculations from Policy Writer
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Co-Pay Structure Display:</strong> Category-wise co-payment breakdown with calculations
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Deductibles & Sublimits:</strong> Compulsory deductible, procedure limits, pre/post natal coverage
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Consistent Burnt Color Theme:</strong> Professional standardized appearance throughout
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Firestore Data Synchronization:</strong> All policy data synced with Policy Writer system
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>3-Page Comprehensive Document:</strong> Complete professional healthcare authorization
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Extensive Terms & Conditions:</strong> 25+ detailed legal and medical clauses
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ color: '#28a745', fontSize: '16px' }}>✅</span>
            <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
              <strong>Professional Authorization Layout:</strong> Multi-signature verification system
            </span>
          </div>
        </div>
      </div>

      {/* Sample Data Display */}
      <div style={{ 
        backgroundColor: '#F5DEB3', 
        padding: '15px', 
        borderRadius: '8px',
        border: '1px solid #CD853F',
        marginBottom: '20px'
      }}>
        <h4 style={{ color: '#8B4513', marginTop: '0', marginBottom: '10px' }}>
          📋 Current Data Preview with Dynamic Policy Verification:
        </h4>
        <div style={{ fontSize: '12px', lineHeight: '1.4' }}>
          <strong>Patient:</strong> {sampleApplication.patient?.name} | 
          <strong> Application ID:</strong> {sampleApplication.applicationId} | 
          <strong> Hospital:</strong> {sampleKypData.applicationDetails?.hospitalName}
          <br />
          <strong>Room Eligibility:</strong> {sampleKypData.policyVerification?.roomEligibility?.type} (₹{sampleKypData.policyVerification?.roomEligibility?.dailyLimit}/day) | 
          <strong> Co-Pay Items:</strong> {sampleKypData.policyVerification?.coPayStructure?.length} categories | 
          <strong> Deductibles:</strong> {sampleKypData.policyVerification?.deductiblesAndSublimits?.length} items
        </div>
      </div>

      {/* Live Preview - Commented out as it's not needed for the current modal-based approach */}
      {/* 
      {isPreviewMode && (
        <div style={{ 
          backgroundColor: 'white', 
          border: '2px solid #1e4d72',
          borderRadius: '8px',
          overflow: 'hidden',
          marginTop: '20px'
        }}>
          <div style={{ 
            backgroundColor: '#1e4d72', 
            color: 'white', 
            padding: '10px 15px',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            📄 Live PDF Preview
          </div>
          <div style={{ height: '600px' }}>
            <PDFViewer
              style={{ width: '100%', height: '100%', border: 'none' }}
              showToolbar={true}
            >
              <ComprehensiveKYPDocument application={sampleApplication} kypData={sampleKypData} />
            </PDFViewer>
          </div>
        </div>
      )}
      */}

      {/* Technical Information */}
      <div style={{ 
        backgroundColor: '#fff3cd', 
        padding: '15px', 
        borderRadius: '8px',
        border: '1px solid #ffeaa7',
        marginTop: '20px'
      }}>
        <h4 style={{ color: '#856404', marginTop: '0' }}>🔧 Technical Implementation:</h4>
        <ul style={{ fontSize: '14px', lineHeight: '1.6', paddingLeft: '20px' }}>
          <li><strong>Library:</strong> @react-pdf/renderer (Better than jsPDF)</li>
          <li><strong>Layout:</strong> Flexbox-based positioning for perfect alignment</li>
          <li><strong>Typography:</strong> Professional font hierarchy and spacing</li>
          <li><strong>Components:</strong> Modular structure for easy maintenance</li>
          <li><strong>Data binding:</strong> Dynamic content from application and KYP data</li>
          <li><strong>Styling:</strong> CSS-in-JS with professional color schemes</li>
        </ul>
      </div>

      {/* KYP Preview Modal */}
      {showPreview && (
        <KYPPreviewModal
          isOpen={showPreview}
          onClose={() => setShowPreview(false)}
          application={sampleApplication}
          kypData={sampleKypData}
        />
      )}
    </div>
  );
};

export default KYPPDFGenerator;
